/**
 * CRA sets `PUBLIC_URL` when `package.json` has `"homepage": "/subpath"`.
 * BrowserRouter must use the same basename or deep links and assets break.
 */
export function getRouterBasename(): string | undefined {
  const raw = process.env.PUBLIC_URL;
  if (raw == null || raw === '' || raw === '/') {
    return undefined;
  }
  const s = String(raw).replace(/\/$/, '');
  return s === '' ? undefined : s;
}

/** Full path to login (respects admin subpath when basename is set). */
export function loginPath(): string {
  return '/login';
}

export function redirectToLoginPage(): void {
  if (typeof window === 'undefined') return;
  const base = getRouterBasename();
  const path = loginPath();
  window.location.href = base ? `${base}${path}` : path;
}
